// extracted by mini-css-extract-plugin
export default {"button":"wq-z","reviewSort":"xq-z"};